import React from "react";
import { Box, Flex, Image, Link, Container } from "@chakra-ui/react";
import logo from "../images/logo.png";
import { useLocation } from "react-router-dom";

function Header() {
  const location = useLocation();
  const activeLink =
    location.pathname === "/" ? "home" : location.pathname.slice(1);

  return (
    <Box
      as="header"
      position="absolute"
      top={0}
      left={0}
      width="100%"
      zIndex={10}
      bg="transparent"
      py={[4, 6]} // Adjust padding based on screen size
    >
      <Container maxW="container.xl">
        <Flex
          justify="space-between"
          align="center"
          direction={["column", "row"]} // Stack on mobile, horizontal on tablet and up
          wrap="wrap"
        >
          {/* Logo */}
          <Image
            src={logo}
            alt="Annie's Nails Logo"
            boxSize={["100px", "150px", "200px"]} // Smaller logo on mobile
            objectFit="contain"
            mb={[4, 0]} // Margin bottom for mobile, 0 for larger screens
          />

          {/* Navigation */}
          <Flex
            as="nav"
            gap={[5, 10]} // Smaller gap on mobile
            fontSize={["16px", "20px"]} // Smaller font on mobile
            fontFamily="Playwrite DE SAS, cursive"
            fontWeight="300"
            className="nav"
            textAlign="center"
            flexWrap="wrap" // Wrap links on small screens
          >
            {["home", "about", "services", "contact"].map((link) => (
              <Link
                key={link}
                color={activeLink === link ? "#f56ee8" : "white"}
                fontWeight={activeLink === link ? "600" : "normal"}
                borderBottom={
                  activeLink === link ? "3px solid #f56ee8" : "none"
                }
                _hover={{ borderBottom: "3px solid #f56ee8" }}
                padding={["8px 12px", "14px 16px"]} // Smaller padding for mobile
                href={link === "home" ? "/" : `/${link}`}
                style={{ textDecoration: "none" }}
              >
                {link.charAt(0).toUpperCase() + link.slice(1)}
              </Link>
            ))}
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
}

export default Header;
